import { DebouncedTextInput, Group, GroupTitle } from "ra-friendsofbabba";
import { email, required, useTranslate } from "ra-core";

import React from "react";

const CompanyReferentInput = ({
  source,
  companyFieldLabel,
  companyTypeId,
  classes,
  requiredValidator,
  ...props
}) => {
  const translate = useTranslate();
  if (companyTypeId <= 0) {
    return null;
  }
  return (
    <Group wrapper>
      <GroupTitle title={translate(companyFieldLabel("referent.title"))} />

      {companyTypeId > 0 && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("referent_name")}
          source={`${source}.referent_name`}
          maxLength={100}
          validate={requiredValidator ? requiredValidator() : required()}
        />
      )}
      {companyTypeId > 0 && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("referent_role")}
          source={`${source}.referent_role`}
          maxLength={100}
          validate={requiredValidator ? requiredValidator() : required()}
        />
      )}
      {companyTypeId > 0 && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("referent_email")}
          source={`${source}.referent_email`}
          maxLength={250}
          validate={[
            requiredValidator ? requiredValidator() : required(),
            email(),
          ]}
        />
      )}
    </Group>
  );
};

export default CompanyReferentInput;
